export enum EditPaymentPageDialogType {
  ADMINISTRATION = 'ADMINISTRATION',
}
